// Session handshake, keepalive, resume, Rithmic login (SPEC §7.1, §6.4).

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=none"
// @generated from file helm/v1/session.proto (package helm.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { LoginConnState, LoginRetryState, NoticeLevel, PlantState, SessionStatus, TradingEnvironment } from "./common_pb";
import { file_helm_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file helm/v1/session.proto.
 */
export const file_helm_v1_session: GenFile = /*@__PURE__*/
  fileDesc("ChVoZWxtL3YxL3Nlc3Npb24ucHJvdG8SB2hlbG0udjEiPAoFSGVsbG8SCwoDand0GAEgASgJEhYKDmNsaWVudF92ZXJzaW9uGAIgASgJEg4KBnRhYl9pZBgDIAEoCSKKAQoHV2VsY29tZRISCgpzZXNzaW9uX2lkGAEgASgJEhMKC3NlcnZlcl9tb2RlGAIgASgJEhcKD2dhdGV3YXlfdmVyc2lvbhgDIAEoCRIQCghsYXN0X3NlcRgEIAEoBBIaChJtYXJrZXRfZGF0YV9zb3VyY2UYBSABKAkSDwoHYm9vdF9pZBgGIAEoCSIbCgRQaW5nEhMKC3RfY2xpZW50X21zGAEgASgGIkQKBFBvbmcSEwoLdF9jbGllbnRfbXMYASABKAYSDwoHdF9nd19tcxgCIAEoBhIWCg5yaXRobWljX3J0dF9tcxgDIAEoDSIaCgZSZXN1bWUSEAoIbGFzdF9zZXEYASABKAQiMgoMUml0aG1pY0xvZ2luEhAKCGxvZ2luX2lkGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIiEKDVJpdGhtaWNMb2dvdXQSEAoIbG9naW5faWQYASABKAki2wEKC0xvZ2luU3RhdHVzEhAKCGxvZ2luX2lkGAEgASgJEiYKBXN0YXRlGAIgASgOMhcuaGVsbS52MS5Mb2dpbkNvbm5TdGF0ZRIOCgZkZXRhaWwYAyABKAkSMAoLZW52aXJvbm1lbnQYBCABKA4yGy5oZWxtLnYxLlRyYWRpbmdFbnZpcm9ubWVudBITCgtzeXN0ZW1fbmFtZRgFIAEoCRIXCg90cmFkaW5nX2VuYWJsZWQYBiABKAgSIgoFcmV0cnkYByABKAsyEy5oZWxtLnYxLkxvZ2luUmV0cnkijQEKCkxvZ2luUmV0cnkSJwoFc3RhdGUYASABKA4yGC5oZWxtLnYxLkxvZ2luUmV0cnlTdGF0ZRIPCgdhdHRlbXB0GAIgASgNEhQKDG1heF9hdHRlbXB0cxgDIAEoDRISCgpuZXh0X2F0X21zGAQgASgDEg4KBnJlYXNvbhgFIAEoCRILCgN3aHkYBiABKAkiUAoLUGxhbnRTdGF0dXMSDQoFcGxhbnQYASABKAkSIgoFc3RhdGUYAiABKA4yEy5oZWxtLnYxLlBsYW50U3RhdGUSDgoGZGV0YWlsGAMgASgJIvkBCgxTZXNzaW9uU3RhdGUSEAoIbG9naW5faWQYASABKAkSJgoGc3RhdHVzGAIgASgOMhYuaGVsbS52MS5TZXNzaW9uU3RhdHVzEiQKBnBsYW50cxgDIAMoCzIULmhlbG0udjEuUGxhbnRTdGF0dXMSDgoGZGV0YWlsGAQgASgJEjAKC2Vudmlyb25tZW50GAUgASgOMhsuaGVsbS52MS5UcmFkaW5nRW52aXJvbm1lbnQSFwoPdHJhZGluZ19lbmFibGVkGAYgASgIEhMKC3N5c3RlbV9uYW1lGAcgASgJEhkKEW1hbnVhbF9sb2NrX3Rva2VuGAggASgJIiIKClN5c3RlbUxpc3QSFAoMc3lzdGVtX25hbWVzGAEgAygJIl0KBk5vdGljZRIjCgVsZXZlbBgBIAEoDjIULmhlbG0udjEuTm90aWNlTGV2ZWwSDAoEY29kZRgCIAEoCRIMCgR0ZXh0GAMgASgJEhIKCmFjY291bnRfaWQYBCABKAkiPwoKRG9jQ2hhbmdlZBIQCghkb2NfdHlwZRgBIAEoCRIOCgZkb2NfaWQYAiABKAkSDwoHdmVyc2lvbhgDIAEoA2IGcHJvdG8z", [file_helm_v1_common]);

/**
 * First frame on every socket, within 5 s of connect, else the gateway closes with 4401.
 *
 * @generated from message helm.v1.Hello
 */
export type Hello = Message<"helm.v1.Hello"> & {
  /**
   * 60 s single-use gateway token minted by helm-api (SPEC §20)
   *
   * @generated from field: string jwt = 1;
   */
  jwt: string;

  /**
   * web build semver
   *
   * @generated from field: string client_version = 2;
   */
  clientVersion: string;

  /**
   * one per browser window/tab
   *
   * @generated from field: string tab_id = 3;
   */
  tabId: string;
};

/**
 * Describes the message helm.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema: GenMessage<Hello> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 0);

/**
 * @generated from message helm.v1.Welcome
 */
export type Welcome = Message<"helm.v1.Welcome"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * "personal" | "multi_tenant" (SPEC §1A.1)
   *
   * @generated from field: string server_mode = 2;
   */
  serverMode: string;

  /**
   * @generated from field: string gateway_version = 3;
   */
  gatewayVersion: string;

  /**
   * highest ordered-event seq the gateway has for this session
   *
   * @generated from field: uint64 last_seq = 4;
   */
  lastSeq: bigint;

  /**
   * Where this gateway's market data and history come from, gateway-derived (never client input):
   * "mock" for a loopback ticker plant, else "<system name>@<host>". Clients namespace their
   * device history cache by it so data from different environments never mixes (SPEC §1.3,
   * SPEC-ADDENDA A1.3, ADR-0028). Empty = no market-data login.
   *
   * @generated from field: string market_data_source = 5;
   */
  marketDataSource: string;

  /**
   * Random id of this gateway process, fixed for its lifetime (a new one after every restart).
   * `session_id` is stable per user across restarts and `last_seq` restarts at 1, so this is the
   * only reliable restart signal: a client that sees it change drops its trading state and
   * resumes from 0 (the new process's ring start, or a Snapshot). Empty from older gateways.
   *
   * @generated from field: string boot_id = 6;
   */
  bootId: string;
};

/**
 * Describes the message helm.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 1);

/**
 * @generated from message helm.v1.Ping
 */
export type Ping = Message<"helm.v1.Ping"> & {
  /**
   * @generated from field: fixed64 t_client_ms = 1;
   */
  tClientMs: bigint;
};

/**
 * Describes the message helm.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 2);

/**
 * @generated from message helm.v1.Pong
 */
export type Pong = Message<"helm.v1.Pong"> & {
  /**
   * @generated from field: fixed64 t_client_ms = 1;
   */
  tClientMs: bigint;

  /**
   * @generated from field: fixed64 t_gw_ms = 2;
   */
  tGwMs: bigint;

  /**
   * gateway <-> Rithmic order-plant heartbeat RTT
   *
   * @generated from field: uint32 rithmic_rtt_ms = 3;
   */
  rithmicRttMs: number;
};

/**
 * Describes the message helm.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 3);

/**
 * Client reconnect: replay ordered events after last_seq from the 5-minute ring (SPEC §7.1).
 *
 * @generated from message helm.v1.Resume
 */
export type Resume = Message<"helm.v1.Resume"> & {
  /**
   * @generated from field: uint64 last_seq = 1;
   */
  lastSeq: bigint;
};

/**
 * Describes the message helm.v1.Resume.
 * Use `create(ResumeSchema)` to create a new message.
 */
export const ResumeSchema: GenMessage<Resume> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 4);

/**
 * Connect this session to a stored Rithmic login (ADR-0027). Trading socket only. The gateway
 * answers with LoginStatus (and SessionState for the order plant); never with the password.
 *
 * @generated from message helm.v1.RithmicLogin
 */
export type RithmicLogin = Message<"helm.v1.RithmicLogin"> & {
  /**
   * rithmic_logins.id; credentials are resolved server-side
   *
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * Session-only mode may carry the password inline exactly once (never stored, never echoed).
   *
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message helm.v1.RithmicLogin.
 * Use `create(RithmicLoginSchema)` to create a new message.
 */
export const RithmicLoginSchema: GenMessage<RithmicLogin> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 5);

/**
 * Disconnect the session from its Rithmic login (log out every plant; no reconnect).
 *
 * @generated from message helm.v1.RithmicLogout
 */
export type RithmicLogout = Message<"helm.v1.RithmicLogout"> & {
  /**
   * must match the connected login; empty = whatever is connected
   *
   * @generated from field: string login_id = 1;
   */
  loginId: string;
};

/**
 * Describes the message helm.v1.RithmicLogout.
 * Use `create(RithmicLogoutSchema)` to create a new message.
 */
export const RithmicLogoutSchema: GenMessage<RithmicLogout> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 6);

/**
 * State of the session's Rithmic login connection (ADR-0027). Ordered, replayable.
 *
 * @generated from message helm.v1.LoginStatus
 */
export type LoginStatus = Message<"helm.v1.LoginStatus"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: helm.v1.LoginConnState state = 2;
   */
  state: LoginConnState;

  /**
   * Rithmic's rp_code text on a rejection, kick explanation…
   *
   * @generated from field: string detail = 3;
   */
  detail: string;

  /**
   * label of the login: TEST / PAPER (paper, prop) / LIVE
   *
   * @generated from field: helm.v1.TradingEnvironment environment = 4;
   */
  environment: TradingEnvironment;

  /**
   * @generated from field: string system_name = 5;
   */
  systemName: string;

  /**
   * the owner's per-login "Allow trading" switch (server-side)
   *
   * @generated from field: bool trading_enabled = 6;
   */
  tradingEnabled: boolean;

  /**
   * set after a refused or failed connect; absent once connected
   *
   * @generated from field: helm.v1.LoginRetry retry = 7;
   */
  retry?: LoginRetry | undefined;
};

/**
 * Describes the message helm.v1.LoginStatus.
 * Use `create(LoginStatusSchema)` to create a new message.
 */
export const LoginStatusSchema: GenMessage<LoginStatus> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 7);

/**
 * The gateway's automatic retry of a refused login (owner decision 2026-10-04): only a transient
 * refusal (rp_code 13 "permission denied", held elsewhere, busy, maintenance, no answer) is tried
 * again, at most max_attempts tries in all; a credential refusal never is.
 *
 * @generated from message helm.v1.LoginRetry
 */
export type LoginRetry = Message<"helm.v1.LoginRetry"> & {
  /**
   * @generated from field: helm.v1.LoginRetryState state = 1;
   */
  state: LoginRetryState;

  /**
   * RETRYING: the try that comes next (2..max); GAVE_UP / STOPPED: tries made
   *
   * @generated from field: uint32 attempt = 2;
   */
  attempt: number;

  /**
   * tries in all, the first one included (5)
   *
   * @generated from field: uint32 max_attempts = 3;
   */
  maxAttempts: number;

  /**
   * RETRYING: unix ms of the next try (the browser counts down to it)
   *
   * @generated from field: int64 next_at_ms = 4;
   */
  nextAtMs: bigint;

  /**
   * Rithmic's refusal as sent ("13 permission denied"), or the network failure
   *
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * NOT_RETRIED: "credential" (user name / password / account) | "unknown"
   *
   * @generated from field: string why = 6;
   */
  why: string;
};

/**
 * Describes the message helm.v1.LoginRetry.
 * Use `create(LoginRetrySchema)` to create a new message.
 */
export const LoginRetrySchema: GenMessage<LoginRetry> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 8);

/**
 * One Rithmic plant of the session's login (CB3). `SessionState.plants` carries "order",
 * "ticker", "history" and "pnl", republished on every transition of any of them.
 * PLANT_STATE_UNSPECIFIED: idle, not logged in yet (history and ticker log in on first use; the
 * PnL feed starts once the order plant is READY, or is switched off).
 *
 * @generated from message helm.v1.PlantStatus
 */
export type PlantStatus = Message<"helm.v1.PlantStatus"> & {
  /**
   * "ticker" | "order" | "history" | "pnl" | "repository"
   *
   * @generated from field: string plant = 1;
   */
  plant: string;

  /**
   * @generated from field: helm.v1.PlantState state = 2;
   */
  state: PlantState;

  /**
   * human-readable: why it is down / reconnecting / degraded
   *
   * @generated from field: string detail = 3;
   */
  detail: string;
};

/**
 * Describes the message helm.v1.PlantStatus.
 * Use `create(PlantStatusSchema)` to create a new message.
 */
export const PlantStatusSchema: GenMessage<PlantStatus> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 9);

/**
 * @generated from message helm.v1.SessionState
 */
export type SessionState = Message<"helm.v1.SessionState"> & {
  /**
   * @generated from field: string login_id = 1;
   */
  loginId: string;

  /**
   * @generated from field: helm.v1.SessionStatus status = 2;
   */
  status: SessionStatus;

  /**
   * @generated from field: repeated helm.v1.PlantStatus plants = 3;
   */
  plants: PlantStatus[];

  /**
   * human-readable (e.g. rp_code text on login reject)
   *
   * @generated from field: string detail = 4;
   */
  detail: string;

  /**
   * order plant's environment, gateway-derived (ADR-0021)
   *
   * @generated from field: helm.v1.TradingEnvironment environment = 5;
   */
  environment: TradingEnvironment;

  /**
   * PAPER / LIVE order plants only: the login's "Allow trading" switch as last read by the
   * gateway (ADR-0027). New orders need it on; exits and cancels do not.
   *
   * @generated from field: bool trading_enabled = 6;
   */
  tradingEnabled: boolean;

  /**
   * @generated from field: string system_name = 7;
   */
  systemName: string;

  /**
   * Ephemeral command identity; changes when the primary orders actor is replaced.
   *
   * @generated from field: string manual_lock_token = 8;
   */
  manualLockToken: string;
};

/**
 * Describes the message helm.v1.SessionState.
 * Use `create(SessionStateSchema)` to create a new message.
 */
export const SessionStateSchema: GenMessage<SessionState> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 10);

/**
 * @generated from message helm.v1.SystemList
 */
export type SystemList = Message<"helm.v1.SystemList"> & {
  /**
   * from RequestRithmicSystemInfo (16/17); never hardcoded
   *
   * @generated from field: repeated string system_names = 1;
   */
  systemNames: string[];
};

/**
 * Describes the message helm.v1.SystemList.
 * Use `create(SystemListSchema)` to create a new message.
 */
export const SystemListSchema: GenMessage<SystemList> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 11);

/**
 * @generated from message helm.v1.Notice
 */
export type Notice = Message<"helm.v1.Notice"> & {
  /**
   * @generated from field: helm.v1.NoticeLevel level = 1;
   */
  level: NoticeLevel;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * The account the notice is about, when it is about one (e.g. POSITIONS_UNCONFIRMED /
   * POSITIONS_CONFIRMED); "" otherwise.
   *
   * @generated from field: string account_id = 4;
   */
  accountId: string;
};

/**
 * Describes the message helm.v1.Notice.
 * Use `create(NoticeSchema)` to create a new message.
 */
export const NoticeSchema: GenMessage<Notice> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 12);

/**
 * A synced document changed (SPEC §1A.3). Clients that did not author it refetch by id.
 *
 * @generated from message helm.v1.DocChanged
 */
export type DocChanged = Message<"helm.v1.DocChanged"> & {
  /**
   * @generated from field: string doc_type = 1;
   */
  docType: string;

  /**
   * @generated from field: string doc_id = 2;
   */
  docId: string;

  /**
   * @generated from field: int64 version = 3;
   */
  version: bigint;
};

/**
 * Describes the message helm.v1.DocChanged.
 * Use `create(DocChangedSchema)` to create a new message.
 */
export const DocChangedSchema: GenMessage<DocChanged> = /*@__PURE__*/
  messageDesc(file_helm_v1_session, 13);

